<template>
  <v-expansion-panel class="mb-3 border rounded-lg overflow-hidden">
    <v-expansion-panel-header class="py-2 grey lighten-5" v-slot="{ open }">
      <div class="d-flex align-center justify-space-between w-100 pr-2 flex-wrap" style="gap: 2px">
        
        <!-- سمت راست: نام پوشه، آیکون و بج تعداد -->
        <div class="d-flex align-center flex-wrap" style="gap: 2px">
          <v-badge
            v-if="group && group.type"
            bordered
            bottom
            color="primary"
            offset-x="6"
            offset-y="6"
          >
            <template v-slot:badge>
              <v-icon x-small color="white">mdi-{{ (getQrTypes(group.type) || {}).icon || 'qrcode' }}</v-icon>
            </template>
            <v-icon color="amber darken-2">
              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
            </v-icon>
          </v-badge>
          <v-icon v-else color="amber darken-2">
            {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
          </v-icon>

          <!-- حالت ویرایش عنوان -->
          <div v-if="isEditing" class="d-flex align-center" @click.stop>
            <v-text-field
              :value="computedFolderTitle"
              dense
              outlined
              hide-details
              autofocus
              @input="$emit('update:title', $event)"
              @keyup.enter="$emit('save-title')"
              style="max-width: 260px"
            />
            <v-btn icon small color="success" @click="$emit('save-title')">
              <v-icon small>mdi-check</v-icon>
            </v-btn>
          </div>

          <!-- حالت نمایش عنوان -->
          <div v-else class="d-flex align-center" style="gap: 2px">
            <span class="font-weight-bold text-subtitle-2">{{ computedFolderTitle }}</span>
            <v-btn icon x-small @click.stop="$emit('start-edit')" title="تغییر نام پوشه">
              <v-icon x-small>mdi-pencil</v-icon>
            </v-btn>
          </div>

          <!-- تعداد کل کیوآر -->
          <v-chip x-small color="amber lighten-5" text-color="amber darken-4" class="mr-2 pa-3">
            <v-icon x-small left color="amber darken-3">mdi-qrcode-scan</v-icon>
            {{ totalItemsCount }} عدد کیوآر
          </v-chip>

          <v-chip v-if="group.dateText" x-small outlined color="grey">
            {{ group.dateText }}
          </v-chip>
        </div>
        <div class="d-flex align-center flex-wrap" style="gap: 2px" @click.stop>
          <v-btn
            small
            class="btn-edit rounded-lg px-2 px-md-3"
            :title="`انتقال خرید کل پوشه`"
            :disabled="transferableCount === 0"
            @click="$emit('transfer-group', group)"
          >
            <v-icon small :class="{ 'ml-1': $vuetify.breakpoint.smAndDown }">mdi-account-arrow-right</v-icon>
            <span class="d-inline">انتقال خرید کل پوشه</span>
          </v-btn>

          <v-btn
            small
            class="btn-buy rounded-lg px-2 px-md-3"
            :title="`انتقال پیش‌خرید کل پوشه`"
            :disabled="transferableCount === 0"
            @click="$emit('transfer-user-group', group)"
          >
            <v-icon small :class="{ 'ml-1': $vuetify.breakpoint.smAndDown }">mdi-account-arrow-left</v-icon>
            <span class="d-inline">انتقال پیش‌خرید کل پوشه</span>
          </v-btn>

          <v-btn
            v-if="selectedInGroup.length > 0"
            small
            outlined
            class="btn-get-code rounded-lg px-2 px-md-3"
            :title="`دانلود انتخابی (${selectedInGroup.length})`"
            :loading="isDownloading"
            @click="$emit('export-items', selectedInGroup.map(i => i.id))"
          >
            <v-icon small :class="{ 'ml-1': $vuetify.breakpoint.smAndDown }">mdi-download</v-icon>
            <span class="d-inline">دانلود انتخابی ({{ selectedInGroup.length }})</span>
          </v-btn>

          <v-btn
            small
            class="btn-get-code rounded-lg px-2 px-md-3"
            :title="`دانلود کامل پوشه (ZIP)`"
            :loading="isDownloading"
            @click="$emit('export-group', group)"
          >
            <v-icon small :class="{ 'ml-1': $vuetify.breakpoint.smAndDown }">mdi-folder-download</v-icon>
            <span class="d-inline">دانلود کامل پوشه (ZIP)</span>
          </v-btn>
        </div>
      </div>
    </v-expansion-panel-header>

    <v-expansion-panel-content class="pt-3">
      <div v-if="!group.items" class="text-center py-8">
        <atom-spinner :animation-duration="1500" :size="50" class="mx-auto" color="var(--v-primary-base)" />
        <div class="caption grey--text mt-2">در حال بارگذاری فایل‌های پوشه...</div>
      </div>

      <!-- جدول کیوآرها -->
      <vue-table v-else
        :headers="headers"
        :data="group.items"
        :props="tableProps"
        :loading="tableLoading"
        :item-class="getRowClass"
        item-key="id"
        :item-selectable="isItemSelectable"
        dense
        :value="selectedItems"
        show-select
        no-data-text="موردی در این پوشه یافت نشد."
        @input="$emit('update:selectedItems', $event)"
        @change="onTableChange"
      >
        <template v-slot:index="{ item }">
          {{ getItemIndex(item) }}
        </template>
        <template v-slot:item.data-table-select="{ item, isSelected, select }">
  <v-simple-checkbox
    v-if="isItemSelectable(item)"
    :value="isSelected"
    color="primary"
    @input="select($event)"
  />
</template>

        <template v-slot:data-table-select="{ item, isSelected, select }">
          <v-simple-checkbox
            v-if="isItemSelectable(item)"
            :value="isSelected"
            color="primary"
            @input="select($event)"
          />  
          <v-icon v-else small color="grey lighten-1">
            mdi-minus
          </v-icon>
        </template>
        
        <template v-slot:image="{ item }">
          <v-avatar :size="$vuetify.breakpoint.smAndDown ? 70 : 80" rounded class="my-1 grey lighten-4">
            <v-img :src="item.image" contain>
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0 flex-column text-center px-1" align="center" justify="center">
                  <v-icon color="grey" class="mb-1">mdi-image-off-outline</v-icon>
                  <span class="text-caption grey--text" style="font-size: 10px !important;">در حال تولید</span>
                </v-row>
              </template>
            </v-img>
          </v-avatar>
        </template>
        
        <template v-slot:expire_days="{ item }">
          <v-chip class="pa-2 rounded-pill" small outlined :color="getOpportunity(item.created_at).color">
            {{ getOpportunity(item.created_at).text }}
          </v-chip>
        </template>
        
        <template v-slot:identifier="{ item }">
          <v-chip class="px-2 py-3 rounded-lg custom-link-chip">
            <v-icon left small :color="item.status === 'transferred' ? '#042FC8' : 'grey'">
              {{ item.status === 'transferred' ? 'mdi-link-variant' : 'mdi-identifier' }}
            </v-icon>
            <template v-if="item.status === 'transferred'">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <a
                    :href="`https://qrland.in/${item.identifier}`"
                    target="_blank"
                    class="d-inline-block text-truncate text-decoration-none"
                    style="max-width: 140px; color: #042FC8; font-weight: bold;"
                    dir="ltr"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop
                  >
                    qrland.in/{{ item.identifier }}
                  </a>
                </template>
                <span>https://qrland.in/{{ item.identifier }}</span>
              </v-tooltip>
              <v-btn icon small @click.stop="$emit('copy-id', `https://qrland.in/${item.identifier}`)" color="#042FC8" class="mr-1">
                <v-icon small>mdi-content-copy</v-icon>
              </v-btn>
            </template>
            <template v-else>
              <span class="font-weight-bold" style="color: #555;">{{ item.identifier }}</span>
            </template>
          </v-chip>
        </template>
        
        <template v-slot:status="{ item }">
          <v-chip small :color="item.status === 'deleted' ? 'error' : item.status === 'transferred' ? 'success' : item.status === 'available' ? 'info' : 'warning'">
            <v-icon small class="pr-1">
              {{ item.status === 'deleted' ? 'mdi-cancel' : item.status === 'transferred' ? 'mdi-account-arrow-right' : item.status === 'available' ? 'mdi-check' : 'mdi-clock' }}
            </v-icon>
            {{ item.status === 'deleted' ? 'حذف شده' : item.status === 'transferred' ? 'منتقل شده' : item.status === 'available' ? 'قابل استفاده' : 'منقضی شده' }}
          </v-chip>
        </template>
        
        <template v-slot:short_code="{ item }">
          <div class="d-flex flex-column text-right py-1">
            <span class="caption">
              <v-icon small color="primary" class="ml-1">mdi-{{ (getQrTypes(item.type) || {}).icon }}</v-icon>
              {{ (getQrTypes(item.type) || {}).name }}
            </span>
            <span class="font-weight-bold text-body-2">{{ item.title }}</span>
          </div>
        </template>
        
        <template v-slot:action="{ item }">
          <action-buttons :data="item" :meta="metaButtons(item)" v-if="item.status !== 'deleted'" />
        </template>
      </vue-table>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import ActionButtons from "@/view/components/adapters/qrList/ordersListButton.vue";

export default {
  name: "AccordionGroup",
  components: {
    ActionButtons,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    isDownloading: {
      type: Boolean,
      default: false,
    },
    metaButtons: {
      type: Function,
      default: () => ({ buttons: [] }),
    },
    getOpportunity: {
      type: Function,
      default: () => ({ expired: false, text: "-", color: "grey" }),
    },
  },
  data() {
    return {
      tableLoading: false,
      tableProps: {
        page: this.group?.items?.current_page || 1,
        length: this.group?.items?.per_page || 10,
      }
    };
  },
  computed: {
    rawItemsArray() {
      if (!this.group || !this.group.items) return [];
      return Array.isArray(this.group.items) 
        ? this.group.items 
        : (this.group.items.data || []);
    },
    computedFolderTitle() {
      return this.group?.folder_name || this.group?.name || 'پوشه بدون نام';
    },
    totalItemsCount() {
      return this.group?.total_items ?? this.group?.items?.total ?? this.rawItemsArray.length ?? 0;
    },
    // کیوآرهایی که قابل انتقال هستند (نه حذف شده و نه منتقل شده)
    transferableItems() {
      return this.rawItemsArray.filter(i => i.status !== 'deleted' && i.status !== 'transferred');
    },
    transferableCount() {
      // اگر از سمت بک‌اند آمار دقیق‌تری ارسال شده اولویت با آن است، در غیر این صورت فیلتر محلی
      return this.group?.available_items ?? this.transferableItems.length;
    },
    selectedInGroup() {
      if (!this.group?.items || !this.selectedItems) return [];
      const groupItemIds = new Set(this.rawItemsArray.map(i => i.id));
      return this.selectedItems.filter(item => groupItemIds.has(item.id));
    },
  },
  watch: {
    'group.items.current_page'(newVal) {
      if (newVal) this.tableProps.page = newVal;
    }
  },
  methods: {
     isItemSelectable(item) {
    const nonSelectable = ['deleted', 'transferred', 'حذف شده', 'منتقل شده'];
    return !nonSelectable.includes(item.status);
  },

  getRowClass(item) {
    return !this.isItemSelectable(item) ? 'row-hide-checkbox' : '';
  },
    getItemIndex(item) {
      const page = this.group?.items?.current_page || 1;
      const perPage = this.group?.items?.per_page || 10;
      const indexInPage = this.rawItemsArray.findIndex(d => d.id === item.id);
      return (page - 1) * perPage + (indexInPage + 1);
    },
    onTableChange(props) {
      this.$emit("change-folder-page", {
        group: this.group,
        folder_id: this.group.id || this.group.folder_id,
        folder_name: this.group.folder_name || this.group.name,
        props: props
      });
    }
  }
};
</script>

<style scoped>
.custom-link-chip {
  background-color: #f5f7fa !important;
  border: 1px solid #e4e7eb;
}
::v-deep .row-hide-checkbox .v-data-table__checkbox,
::v-deep .row-hide-checkbox .v-simple-checkbox {
  visibility: hidden !important;
  pointer-events: none !important;
}
</style>
